module.exports = __webpack_public_path__ + "img/car_question-desktop.b3711e22.svg";